import { render, staticRenderFns } from "./Break.vue?vue&type=template&id=3240ef8c&scoped=true"
import script from "./Break.vue?vue&type=script&lang=js"
export * from "./Break.vue?vue&type=script&lang=js"
import style0 from "./Break.vue?vue&type=style&index=0&id=3240ef8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240ef8c",
  null
  
)

export default component.exports